import { useState, useMemo, useCallback, useEffect, useRef } from 'react'
//
import { fetchPostAdEvent } from 'api'
//
import { VideoTypeEnum } from 'constant/common'
import { useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
//
import { useOpenRankModal } from 'component/AreaBox/hooks/useOpenModal'
//
import {
  Wrapper,
  ContentWrapper,
  TabButton,
  TabButtonRow,
  TopRow,
  BottomRow,
  AdImage,
  StyledButtonSearchMore,
} from './Styled'

import AreaWrapper from 'component/AreaWrapper'

import type { SchemaCmsSectionShow } from 'api'
import { useInView } from 'react-intersection-observer'
import { useTemplates } from 'component/AreaBox/hooks/useTemplates'
import { selectAdInfo } from 'redux/selector/app'
import { AdvertisementType } from 'constant/advertisement'
import { formatDate } from 'utils/timeFormat'
import { useViewport } from 'component/AreaBox/hooks/useViewport'

// 這個是AreaBox的集合版
export default function GroupedAreaBox({ infoList, areaIndex, listData, tabIndex, onTabClick, lazy, ...props }) {
  const [currentTab, setCurrentTab] = useState(tabIndex)
  const tabButtonRowRef = useRef<HTMLDivElement | null>(null)
  const tabButtonRefs = useRef<Array<HTMLButtonElement | null>>([])
  const currentInfo = useMemo<SchemaCmsSectionShow>(() => {
    if (!infoList) return null
    return infoList[currentTab]
  }, [currentTab, infoList])
  // const { finishLoading } = useAreaLoading()
  const adInfo = useSelector(selectAdInfo)
  const { templates } = useTemplates()
  const { finished } = useViewport({ enabled: lazy, count: 0 })

  const { ref } = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true,
  })

  // /** 如果後端回傳 video_sortby 為 random, 則由前端實作 random 邏輯 */
  // const isVideoSortByRandom = useMemo(() => currentInfo?.video_sortby === SORT_BY_RANDOM, [currentInfo?.video_sortby])
  const isMoreVisible = useMemo(() => currentInfo?.more_isvisible === 1, [currentInfo])
  // const isShowTitle = title_is_visible === TRUE
  // /** 是否顯示區域上方的更多 (更多>) */
  // const isShowMore = more_isvisible === TRUE
  // /** 是否顯示區域下方的更多按鈕 */
  // const isShowButtonMore = show_more_isvisible === TRUE
  // /** 是否顯示區域下方的換一批按鈕 */
  // const isShowButtonNext = next_isvisible === TRUE

  const { openViewMoreModal } = useOpenRankModal({
    title: '排行榜',
    infoList,
    tabIndex: currentTab,
    type:
      currentInfo?.type === VideoTypeEnum.LongVideo
        ? 'video'
        : currentInfo?.type === VideoTypeEnum.ShortVideo
        ? 'short'
        : currentInfo?.type === VideoTypeEnum.Comic
        ? 'comic'
        : currentInfo?.type === VideoTypeEnum.Novel
        ? 'novel'
        : 'video',
  })

  const infoData = useMemo(() => {
    return listData[currentTab] || []
  }, [currentTab, listData])

  const Template = useMemo(() => {
    if (!currentInfo || !currentInfo.template_id) return null
    return templates[currentInfo.template_id]
  }, [currentInfo, templates])

  const TemplateComponent = useMemo(() => {
    return Template ? <Template videoData={infoData} /> : <div></div>
  }, [Template, infoData])

  /** 視頻櫥窗下方廣告位 */
  const adAreaBottom = useMemo(() => {
    const adIndex = areaIndex % adInfo?.[AdvertisementType.AreaBottom]?.length
    return adInfo?.[AdvertisementType.AreaBottom]?.[adIndex]
  }, [adInfo, areaIndex])

  const onAdItemClick = useCallback(() => {
    if (adAreaBottom) {
      fetchPostAdEvent({
        date: formatDate(new Date()),
        material_id: adAreaBottom.id,
        material_name: adAreaBottom.name,
        oholo_site_id: adAreaBottom.site_type,
        oholoer_id: adAreaBottom.oholoer_id,
        oholoer_link: adAreaBottom.oholoer_link,
        oholoer_name: adAreaBottom.oholoer_name,
      })
      window.open(adAreaBottom?.link, '_blank')
    } else {
      console.warn('no ad assigned')
    }
  }, [adAreaBottom])

  const onMoreClick = useCallback(() => {
    openViewMoreModal()
  }, [openViewMoreModal])

  const handleTabClick = useCallback(
    (index) => {
      setCurrentTab(index)
      onTabClick(index)
    },
    [onTabClick]
  )

  useEffect(() => {
    const tabButtonRow = tabButtonRowRef.current
    const activeTabButton = tabButtonRefs.current[currentTab]

    if (!tabButtonRow || !activeTabButton || tabButtonRow.scrollWidth <= tabButtonRow.clientWidth) return

    const rowRect = tabButtonRow.getBoundingClientRect()
    const buttonRect = activeTabButton.getBoundingClientRect()
    const left =
      tabButtonRow.scrollLeft + buttonRect.left - rowRect.left - (tabButtonRow.clientWidth - buttonRect.width) / 2

    tabButtonRow.scrollTo({ left, behavior: 'smooth' })
  }, [currentTab])

  // if (!TemplateComponent) return null

  return (
    <Wrapper {...props} ref={ref}>
      <AreaWrapper>
        <ContentWrapper>
          <TopRow>
            <TabButtonRow ref={tabButtonRowRef} role="tablist" aria-label="排行榜分類">
              {infoList.map((m, index) => {
                const isActive = currentTab === index

                return (
                  <TabButton
                    key={'tab_' + index}
                    ref={(element) => {
                      tabButtonRefs.current[index] = element
                    }}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    tabIndex={isActive ? 0 : -1}
                    className={isActive ? 'active' : ''}
                    onClick={() => {
                      handleTabClick(index)
                    }}
                  >
                    {m.title}
                  </TabButton>
                )
              })}
            </TabButtonRow>
            {isMoreVisible && <StyledButtonSearchMore type="button" handleClick={onMoreClick} />}
          </TopRow>

          {TemplateComponent}
        </ContentWrapper>
      </AreaWrapper>
      {(finished || !Template?.lazy) && (
        <BottomRow>
          {/** 視頻櫥窗下方廣告位 */}
          {!isEmpty(adAreaBottom) && (
            // @ts-expect-error ignore type check
            <AdImage src={adAreaBottom.icon_path} source="preview" aspectRatio={374 / 94} onClick={onAdItemClick} />
          )}
        </BottomRow>
      )}
    </Wrapper>
  )
}
